<template>
  <div :class="{ fullscreen: fullscreen }" class="tinymce-container" :style="{ width: containerWidth }">
    <textarea :id="tinymceId" class="tinymce-textarea"/>

    <!-- <div class="custom-box">
      <div class="custom-btn">
        <label>
          <input ref="imagefile" type="file" accept="image/jpg, image/jpeg, image/png, image/gif" class="custom-btn-file" @change="imageFileChange" />
          <span>图片</span>
        </label>
      </div>
      <div class="custom-btn">
        <label>
          <input ref="videofile" type="file" accept="video/*" class="custom-btn-file" @change="videoFileChange" />
          <span>视频</span>
        </label>
      </div>
      <div class="custom-btn" @click="addPage">page</div>
      <div class="custom-btn" @click="addTextPage">文字page</div>
      <div class="custom-btn" @click="addMinplayground">小程序</div>
    </div> -->

    <!-- <weappImgDialog :visible="weappImgDialogVisible" @cancel="weappImgDialogVisible = false" @ok="handleWeappImgDialogOk" />

    <weappLinkDialog :visible="weappLinkDialogVisible" @cancel="weappLinkDialogVisible = false" @ok="handleWeappLinkDialogOk" />

    <weappTextLinkDialog :visible="weappTextLinkDialogVisible" @cancel="weappTextLinkDialogVisible = false" @ok="handleWeappTextLinkDialogOk" /> -->
  </div>
</template>

<script>
/**
 * docs:
 * https://panjiachen.github.io/vue-element-admin-site/feature/component/rich-editor.html#tinymce
 */
import plugins from './plugins'
import toolbar from './toolbar'
import load from './dynamicLoadScript'

import weappImgDialog from './components/weappImgDialog'
import weappLinkDialog from './components/weappLinkDialog'
import weappTextLinkDialog from './components/weappTextLinkDialog'

import config from '@/config'
import store from '@/store'
import axios from 'axios'
import router from '@/router'

// why use this cdn, detail see https://github.com/PanJiaChen/tinymce-all-in-one
// const tinymceCDN = "https://cdn.bootcdn.net/ajax/libs/tinymce/5.4.2/tinymce.min.js";
const tinymceCDN = 'https://lib.baomitu.com/tinymce/5.7.1/tinymce.min.js'

export default {
  name: 'Tinymce',
  components: {weappImgDialog, weappLinkDialog, weappTextLinkDialog},
  props: {
    id: {
      type: String,
      default: function () {
        return 'vue-tinymce-' + +new Date() + ((Math.random() * 1000).toFixed(0) + '')
      }
    },
    value: {
      type: String,
      default: ''
    },
    toolbar: {
      type: Array,
      required: false,
      default() {
        return []
      }
    },
    menubar: {
      type: String,
      // default: 'file edit insert view format table'
      default: ''
    },
    height: {
      type: [Number, String],
      required: false,
      default: 360
    },
    width: {
      type: [Number, String],
      required: false,
      default: 'auto'
    }
  },
  data() {
    return {
      hasChange: false,
      hasInit: false,
      tinymceId: this.id,
      fullscreen: false,
      languageTypeList: {
        en: 'en',
        zh: 'zh_CN',
        es: 'es_MX',
        ja: 'ja'
      },
      editor: null,
      weappImgDialogVisible: false,
      weappLinkDialogVisible: false,
      weappTextLinkDialogVisible: false
    }
  },
  computed: {
    containerWidth() {
      const width = this.width
      if (/^[\d]+(\.[\d]+)?$/.test(width)) {
        // matches `100`, `'100'`
        return `${width}px`
      }
      return width
    }
  },
  watch: {
    value(val) {
      if (!this.hasChange && this.hasInit) {
        this.$nextTick(() => window.tinymce.get(this.tinymceId).setContent(val || ''))
      }
    }
  },
  mounted() {
    this.init()
  },
  activated() {
    if (window.tinymce) {
      this.initTinymce()
    }
  },
  deactivated() {
    this.destroyTinymce()
  },
  destroyed() {
    this.destroyTinymce()
  },
  methods: {
    init() {
      // dynamic load tinymce from cdn
      load(tinymceCDN, (err) => {
        if (err) {
          // this.$message.error(err.message);
          // return;
        }
        this.initTinymce()
      })
    },
    initTinymce() {
      const _this = this
      window.tinymce.init({
        selector: `#${this.tinymceId}`,
        icons: 'custom',
        branding: false,
        draggable_modal: true,
        statusbar: false,
        language: this.languageTypeList['zh'],
        height: this.height,
        body_class: 'panel-body',
        // object_resizing: false,
        toolbar: this.toolbar.length > 0 ? this.toolbar : toolbar,
        menubar: this.menubar,
        plugins: plugins,
        fontsize_formats: '12px 14px 16px 18px 24px 36px 48px 56px 72px',
        end_container_on_empty_block: true,
        powerpaste_word_import: 'clean',
        code_dialog_height: 450,
        code_dialog_width: 1000,
        advlist_bullet_styles: 'square',
        advlist_number_styles: 'default',
        imagetools_cors_hosts: ['www.tinymce.com', 'codepen.io'],
        default_link_target: '_blank',
        link_title: false,
        nonbreaking_force_tab: true, // inserting nonbreaking space &nbsp; need Nonbreaking Space Plugin
        extended_valid_elements:
            'wx-open-launch-weapp[appid|toutiaoid|username|path|sparepath],img[appid|toutiaoid|username|path|src|alt|sparepath|linkpath],open-link[linkpath],open-link1[linkpath]',
        custom_elements: '~wx-open-launch-weapp,~open-link,~open-link1',
        image_advtab: true,
        images_upload_handler: (blobInfo, succFun, failFun) => {
          const file = blobInfo.blob()
          this.uploadFile(file)
              .then((res) => {
                succFun(res.data.data.url)
              })
              .catch((err) => {
                failFun(err.message)
              })
        },
        init_instance_callback: (editor) => {
          if (_this.value) {
            editor.setContent(_this.value)
          }
          _this.hasInit = true
          editor.on('Change KeyUp SetContent', () => {
            _this.hasChange = true
            _this.$emit('input', editor.getContent())
          })
        },
        setup(editor) {
          _this.editor = editor
          editor.on('FullscreenStateChanged', (e) => {
            _this.fullscreen = e.state
          })
        },
        convert_urls: false
      })
    },
    destroyTinymce() {
      const tinymce = window.tinymce.get(this.tinymceId)
      if (this.fullscreen) {
        tinymce.execCommand('mceFullScreen')
      }

      if (tinymce) {
        tinymce.destroy()
      }
    },
    setContent(value) {
      window.tinymce.get(this.tinymceId).setContent(value)
    },
    getContent() {
      window.tinymce.get(this.tinymceId).getContent()
    },
    imageSuccessCBK(arr) {
      const _this = this
      this.$emit('getImageObj', arr)
      arr.forEach((v) => {
        window.tinymce.get(_this.tinymceId).insertContent(`<img class="wscnph" src="${v.url}" >`)
      })
    },
    addPage() {
      this.weappLinkDialogVisible = true
    },
    addTextPage() {
      this.weappTextLinkDialogVisible = true
    },
    addMinplayground() {
      this.weappImgDialogVisible = true
    },
    // 插入小程序
    handleWeappImgDialogOk(data) {
      this.weappImgDialogVisible = false
      const img_url = data.img_url[0].url
      this.editor.selection.setContent(`
        <wx-open-launch-weapp
          appid=${data.appid}
          toutiaoid=${data.toutiaoid}
          username=${data.username}
          path=${data.url}
          sparepath=${data.spareUrl}>
          <img
            appid=${data.appid}
            toutiaoid=${data.toutiaoid}
            username=${data.username}
            path=${data.url}
            sparepath=${data.spareUrl}
            src=${img_url}
          />
        </wx-open-launch-weapp>
      `)
    },
    handleWeappLinkDialogOk(data) {
      this.weappLinkDialogVisible = false
      const img_url = data.img_url[0].url
      this.editor.selection.setContent(`
        <open-link
          linkpath=${data.path}><img
            linkpath=${data.path}
            src=${img_url}
          />
        </open-link>
      `)
    },
    handleWeappTextLinkDialogOk(data) {
      this.weappTextLinkDialogVisible = false
      this.editor.selection.setContent(`
        <open-link1
          linkpath=${data.path}><a 
          href=${data.path}>${data.title}</a>
        </open-link1>
      `)
    },
    imageFileChange() {
      const loading = router.app.$loading({text: '正在上传'})
      const input = this.$refs.imagefile
      const file = input.files[0]
      if (!file) return
      this.uploadFile(file)
          .then((res) => {
            loading.close()
            input.value = ''
            this.editor.selection.setContent(`<img src=${res.data.data.url} />`)
          })
          .catch(() => {
            loading.close()
            input.value = ''
            this.$message.error('上传失败')
          })
    },
    videoFileChange() {
      const loading = router.app.$loading({text: '正在上传'})
      const input = this.$refs.videofile
      const file = input.files[0]
      if (!file) return
      this.uploadFile(file)
          .then((res) => {
            loading.close()
            input.value = ''
            this.editor.selection.setContent(`
            <video controls="controls">
              <source src="${res.data.data.url}"></source>
            </video>
          `)
          })
          .catch((err) => {
            loading.close()
            input.value = ''
            this.$message.error('上传失败')
          })
    },
    uploadFile(file) {
      return new Promise((reslove, reject) => {
        const param = new FormData() // 创建form对象
        param.append('file', file, file.name)
        param.append('type','image')
        param.append('folder','product-banners')
        const configs = {
          headers: {
            Authorization: `Bearer ${store.state.auth.token}`,
            'Content-Type': 'multipart/form-data'
          },
          transformRequest: [(data) => data]
        }
        axios
            .post(config.upload.url, param, configs)
            .then((res) => {
              reslove(res)
            })
            .catch((err) => {
              reject(err)
            })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.tinymce-container {
  position: relative;
  line-height: normal;
}

.tinymce-container {
  ::v-deep {
    .mce-fullscreen {
      z-index: 100;
    }
  }
}

.tinymce-textarea {
  visibility: hidden;
  z-index: -1;
}

.editor-custom-btn-container {
  position: absolute;
  right: 4px;
  top: 4px;
  /*z-index: 2005;*/
}

.fullscreen .editor-custom-btn-container {
  z-index: 100;
  position: fixed;
}

.editor-upload-btn {
  display: inline-block;
}

.custom-box {
  position: absolute;
  top: -40px;
  right: 20px;
  z-index: 1;
  display: flex;

  .custom-btn {
    margin-left: 10px;
    padding: 5px;
    cursor: pointer;
    position: relative;

    .custom-btn-file {
      display: none;
    }

    > label {
      cursor: pointer;
    }
  }
}

/deep/ .tox .tox-tbtn svg {
  fill: #666;
}

/deep/ .tox-toolbar {
  /deep/ .tox-icon {
    transform: scale(0.8);
  }
}
</style>

<style>
.tox .tox-toolbar,
.tox .tox-toolbar__overflow,
.tox .tox-toolbar__primary {
  background: none !important;
  border-bottom: 1px solid #e8e8e8;
}
</style>
